import usuariosStore from "../stores/UsuariosStore";
import { useState } from "react";
import { observer } from "mobx-react";
import carritoStore from "../stores/CarritoStore";
import sidebarStore from "./sidebar/SidebarStore";
import { cdnURL } from "../utils/api";
import { validateEmail } from "../utils/utils";
import '../css/bootstrap-grid.min.css';
import globals from "../globals";
import {isMobile} from "react-device-detect";

const anchoCarrito = globals.anchoCarrito;

function currency(num, sign = '$') {
    if (!num) { return `$ 0.00` }
    if (typeof(num) == "string")
        num = parseFloat(num);
    return sign + ' ' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}

function _Carrito(props) {
    const { confirmacion } = props;
    const [enviando, setEnviando] = useState(false);
    const [errorInvitado, setErrorInvitado] = useState('');

    const validarInvitado = () => {
        const { name, lastName, email, phone } = carritoStore.datosInvitado;
        if (!name || !lastName || !email || !phone) {
            setErrorInvitado('Completá todos los datos de contacto.');
            return false;
        }
        if (!validateEmail(email)) {
            setErrorInvitado('Chequeá que el email esté correcto.');
            return false;
        }
        if (phone.length < 8) {
            setErrorInvitado('Chequeá que el teléfono esté correcto.');
            return false;
        }
        setErrorInvitado('');
        return true;
    };

    const enviarPedido = async () => {
        if (!usuariosStore.logged && !validarInvitado())
            return;
        setEnviando(true);
        const [failed, msg] = await carritoStore.enviar();
        setEnviando(false);
        if (!failed) {
            sidebarStore.show(<CarritoEnviadoOK msg={msg} />, '40vw');
        } else {
            sidebarStore.show(<CarritoEnviadoERROR msg={msg} />, '40vw');
        }
    };

    return (
        <div className={'carrito'}>
            { !confirmacion && <h1>PEDIDO</h1> }
            { confirmacion && <h1>CONFIRMAR PEDIDO</h1> }
            <div className={'carrito-productos'}>
                <div className={'row carrito-productos-header'}>
                    <div className={'desktop col-1'}></div>
                    <div className={'desktop col-2'}>CANT</div>
                    <div className={'desktop col-4'}>PRODUCTO</div>
                    <div className={'desktop col-2'}>PRECIO UNITARIO</div>
                    <div className={'desktop col-2'}>PRECIO TOTAL</div>
                    <div className={'desktop col-1'}></div>
                </div>

                <div className={'row carrito-productos-listado'}>
                    {carritoStore.carrito.map((p, idx) => (
                        <div className={'row'} key={p.id + '-' + idx}>
                            <div className={'d-none d-sm-block col-1'}>
                                <img src={cdnURL(p.imagen, '/img/prod_default.png')} />
                            </div>
                            <div className={'col-xl-2 col-lg-2 col-md-2 col-sm-3'}>
                                <span className={'label-mobile mobile'}
                                    style={{marginTop: '7px'}}> CANT: &nbsp; </span>
                                <span className={'carrito-productos-cant-confirmacion'}> {p.quantity} </span><br />
                                { p.quantity_extended && Object.keys(p.quantity_extended).map(t => (
                                    <div className={'carrito-productos-cant-confirmacion'} style={{fontSize: '10px'}} key={t}> TALLE {t}: {p.quantity_extended[t]} </div>
                                ))}
                            </div>
                            <div className={'col-xl-4 col-lg-4 col-md-4 col-sm-9'}>
                                <span className={'label-mobile mobile'}> PROD: </span>
                                {p.name}</div>
                            <div className={'col-xl-2 col-lg-2 col-md-2 col-sm-4'}>
                                <span className={'label-mobile mobile'}> PRECIO UNITARIO: </span>
                                {currency(p.price)}</div>
                            <div className={'col-xl-2 col-lg-2 col-md-2 col-sm-4'}>
                                <span className={'label-mobile mobile'}> PRECIO TOTAL: </span>
                                {currency(p.quantity * p.price)}</div>

                            {!confirmacion &&
                                <div className={'col-12 mobile'}>
                                    <button className={'boton-borrar-mobile'}
                                            onClick={() => carritoStore.borrarIdx(idx)}>
                                        BORRAR &nbsp;
                                        <i className="fa-solid fa-trash carrito-trash"/>
                                    </button>
                                </div>
                            }
                            {!confirmacion &&
                                <div className={'col-1 desktop'}>
                                    <i className="fa-solid fa-trash carrito-trash"
                                       onClick={() => carritoStore.borrarIdx(idx)}
                                    ></i>
                                </div>
                            }
                        </div>
                    ))}
                </div>

                <div className={'row carrito-productos-total'}>
                    <div className={'desktop col-2'}> TOTAL </div>
                    <div className={'desktop col-6 text-center'}>
                        {carritoStore.cant()} PRODUCTOS DISTINTOS CON {carritoStore.cantTotal()} ITEMS
                    </div>
                    <div className={'desktop col-4 text-right'}> {currency(carritoStore.total())} </div>
                </div>
            </div>

            { !confirmacion && 
                <div className={'row carrito-acciones'}>
                    <div className={ carritoStore.cant() > 0 ? 'col-6' : 'col-12' }>
                        <button onClick={() => sidebarStore.hide()}> Seguir Comprando</button>
                    </div>
                    { carritoStore.cant() > 0 &&
                    <div className={'col-6'}>
                        <button className={'enviar'}
                                onClick={() => {
                                    sidebarStore.show(<Carrito confirmacion={true}/>, anchoCarrito)
                                }}
                        > Confirmar Pedido
                        </button>
                    </div>
                    }
                </div>
            }
            { confirmacion &&
                <div className={'carrito-productos'} style={{marginTop: '20px'}}>
                    <div className={'carrito-productos-header'} style={{textTransform: 'uppercase', fontWeight: '600', fontSize: '18px'}}>
                        Dejanos tus datos para contactarte y coordinar el pago y la entrega.
                        <br /><br />
                    </div>

                    {!usuariosStore.logged &&
                        <div className={'row'} style={{marginBottom: '15px'}}>
                            <div className={'col-12 col-md-6 mb-2'}>
                                <label className={'form-label'}>Nombre</label>
                                <input
                                    className={'form-control'}
                                    type={'text'}
                                    value={carritoStore.datosInvitado.name}
                                    onChange={e => carritoStore.setDatosInvitado('name', e.target.value)}
                                />
                            </div>
                            <div className={'col-12 col-md-6 mb-2'}>
                                <label className={'form-label'}>Apellido</label>
                                <input
                                    className={'form-control'}
                                    type={'text'}
                                    value={carritoStore.datosInvitado.lastName}
                                    onChange={e => carritoStore.setDatosInvitado('lastName', e.target.value)}
                                />
                            </div>
                            <div className={'col-12 col-md-6 mb-2'}>
                                <label className={'form-label'}>E-Mail</label>
                                <input
                                    className={'form-control'}
                                    type={'email'}
                                    value={carritoStore.datosInvitado.email}
                                    onChange={e => carritoStore.setDatosInvitado('email', e.target.value)}
                                />
                            </div>
                            <div className={'col-12 col-md-6 mb-2'}>
                                <label className={'form-label'}>Teléfono</label>
                                <input
                                    className={'form-control'}
                                    type={'tel'}
                                    value={carritoStore.datosInvitado.phone}
                                    onChange={e => carritoStore.setDatosInvitado('phone', e.target.value)}
                                />
                            </div>
                            {errorInvitado &&
                                <div className={'col-12'} style={{color: '#c00', fontSize: '13px', marginBottom: '8px'}}>
                                    {errorInvitado}
                                </div>
                            }
                        </div>
                    }

                    <label className={'form-label'}>Comentario / indicaciones</label>
                    <textarea
                        rows={usuariosStore.logged ? 10 : 5}
                        className={'agregar-carrito-comentario'}
                        value={carritoStore.comentario}
                        onChange={e => carritoStore.setComentario(e.target.value)}
                        placeholder={'Ej: horario de entrega, referencias, etc.'}
                    />
                </div>
            }
            { confirmacion &&
                <div className={'row carrito-acciones'}>
                    <div className={'col-6'}>
                        <button onClick={() => ShowCarrito()} disabled={enviando}> Volver </button>
                    </div>
                    <div className={'col-6'}>
                        <button className={'enviar'}
                                disabled={enviando}
                                onClick={enviarPedido}
                        > {enviando ? 'Enviando...' : 'Enviar Pedido'}
                        </button>
                    </div>
                </div>
            }
        </div>
    )
}
const Carrito = observer(_Carrito);

function CarritoEnviadoOK(props) {
    return (
        <div className={'col-12 carrito-acciones text-center'}>
            Muchas gracias por su compra.<br /><br />
            El identificador de su orden es #{props.msg} <br /><br /><br />
            <button className={'enviar'} onClick={async () => sidebarStore.hide()}>
                Cerrar
            </button>
        </div>
    );
}

function CarritoEnviadoERROR(props) {
    return (
        <div className={'col-12 carrito-acciones text-center'}>
            Hubo un error generando la orden. ({props.msg})<br /><br />
            Vuelva a intentar en unos minutos o contactese con nosotros.<br /><br /><br />
            <button className={'enviar'} onClick={async () => ShowCarrito() }>
                Volver al Carrito
            </button>
        </div>
    );
}

function CarritoIcono() {
    return (
        <div className={'carrito-icono'} 
        style={{ marginLeft: isMobile ? 'auto' : 'none', textAlign: isMobile ? 'center' : 'none', marginTop: isMobile ? '17px' : 'none' }}
        onClick={() => {
            ShowCarrito();
        }}>
            <i className="fa-solid fa-cart-shopping"></i>
            {carritoStore.cant() > 0 &&
                <div className={'carrito-icono-cant'}
                style={{ marginLeft: isMobile ? '50%' : 'none', width: isMobile ? '45px' : 'none' }}
                >{carritoStore.cant()}</div>
            }
        </div>
    );
}
export default observer(CarritoIcono);

export function ShowCarrito() {
    //window.scrollTo(0, 0);
    sidebarStore.show(<Carrito />, anchoCarrito);
}
